import * as common from '../common'

/*
 * BCH's own cell rules, on top of `common.SheetRow`: its workbooks use `-` as
 * a blank, and a missing amount counts as zero. Shared by the parsers in
 * cash-draw.ts and justifications/workbook-data.ts; not exported from the
 * bch index.
 */

/**
 * A cell as trimmed text, treating the workbooks' placeholder blank (`-`) as
 * missing.
 */
export function normalizeText(value: unknown) {
  const text = common.SheetRow.cellText(value)
  return text === '-' ? undefined : text
}

/**
 * A cell amount, with a missing or non-numeric cell counted as zero.
 */
export function parseNumber(value: unknown) {
  return common.SheetRow.parseOptionalNumber(value) ?? 0
}

/**
 * A cell as an ISO date, treating the placeholder blank (`-`) as missing.
 */
export function normalizeDate(value: unknown) {
  return normalizeText(value) === undefined
    ? undefined
    : common.SheetRow.cellDate(value)
}
